module.exports = __webpack_public_path__ + "static/media/icon-moduleA1.4199f646.png";